export default __webpack_public_path__ + "img/icon-sound-active.e08d29b5.svg";